const COLORS = {
  PRIMARY: '#2d2e40',
  SECONDARY: '#719dd0',
  HINTED: '#ff4c5a',
  SELECTED: '#ab7ca0',
  WHITE: '#fff',
};

export {COLORS};
